import { FormField } from "@/components/elements/FormField/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Textarea } from "@/components/elements/Textarea";
import { TLearnerNotesForm } from "@/features/learning-progress/schema/useLearnerNotesSchema";
import { black, divider } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

type TProps = {
  readOnly?: boolean;
};

export const OrganizationReportEditSection: FC<TProps> = ({ readOnly = false }) => {
  const { control } = useFormContext<TLearnerNotesForm>();

  return (
    <InnerBox
      p={3}
      showDivider={false}
      borderColor={divider.high}
      bordered
      title="所属機関様への報告"
    >
      <Stack mt={1} gap={1}>
        <Typography variant="cap12" color={black[70]}>
          報告内容
        </Typography>
        <FormField control={control} name="companyReport" noLabel>
          <Textarea readonly={readOnly} placeholder="入力してください" minRows={5} maxRows={10} />
        </FormField>
      </Stack>
    </InnerBox>
  );
};
